import {
    TransactionColumn,
    TransactionView,
} from "@common/types/views/transactionViews";

export const SCHEDULE_TEMPLATE_SEARCH_PARAM = "scheduleTemplateId";

const SCHEDULE_HANDOFF_VARIANT = "schedule-handoff";

function isInjectedScheduleColumn(
    column: TransactionView["columns"][number],
): boolean {
    return (
        column.id === TransactionColumn.SCHEDULE &&
        column.options?.customVariants?.variant === SCHEDULE_HANDOFF_VARIANT
    );
}

export function injectScheduleColumn(view: TransactionView): TransactionView {
    if (
        view.columns.some((column) => column.id === TransactionColumn.SCHEDULE)
    ) {
        return view;
    }
    const amountColumnIndex = view.columns.findIndex(
        (column) => column.id === TransactionColumn.AMOUNT,
    );
    const insertAt =
        amountColumnIndex < 0 ? view.columns.length : amountColumnIndex + 1;
    return {
        ...view,
        columns: [
            ...view.columns.slice(0, insertAt),
            {
                id: TransactionColumn.SCHEDULE,
                options: {
                    pin: "right",
                    customVariants: { variant: SCHEDULE_HANDOFF_VARIANT },
                },
            },
            ...view.columns.slice(insertAt),
        ],
    };
}

export function stripInjectedScheduleColumn(
    view: TransactionView,
): TransactionView {
    return {
        ...view,
        columns: view.columns.filter(
            (column) => !isInjectedScheduleColumn(column),
        ),
    };
}
